import React, { useEffect } from 'react';
import { ShadcnReactTable } from '@talentmesh/table';
import { useActionDialogContext } from '../../components/dialogs/Context/ActionDialogContext';
import { useCandidatesOverviewContext } from '../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import { useCandidatesTableContext } from '../Contexts/CandidatesTableContext/CandidatesTableContext';
import TableFilters from './CandidatesTable/TableFilters';
import TableNav from './CandidatesTable/TableNav';
import CandidatesTablePaper from '../../components/CandidatesListPaper';
import CandidatesTableContainer from '../../components/CandidatesTableContainer';

function CandidatesOverviewList() {
    const { loadPageAsync } = useCandidatesOverviewContext();
    const { candidateStatuses } = useActionDialogContext();
    const table = useCandidatesTableContext();

    useEffect(() => {
        loadPageAsync();
    }, [candidateStatuses]);

    return (
        <CandidatesTablePaper data-cy="candidatesOverviewList">
            <TableFilters />
            <CandidatesTableContainer>
                <ShadcnReactTable table={table} />
            </CandidatesTableContainer>
            <TableNav />
        </CandidatesTablePaper>
    );
}

export default CandidatesOverviewList;
